<template>
    <div>
        <template v-if="crud_income_tax_slabs == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add IncomeTax Slab </h1>
            </div>
            <div class="global-main">
                <form id="incomeTaxSlabForm" @submit.prevent="addIncomeTaxSlabData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Minimum Income </label>
                            <input v-model="form.min_income" type="text" name="min_income" class="form-control" :class="{ 'is-invalid': form.errors.has('min_income') }">
                            <has-error :form="form" field="min_income"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Maximum Income </label>
                            <input v-model="form.max_income" type="text" name="max_income" class="form-control" :class="{ 'is-invalid': form.errors.has('max_income') }">
                            <has-error :form="form" field="max_income"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Fixed Tax </label>
                            <input v-model="form.fixed_tax" type="text" name="fixed_tax" class="form-control" :class="{ 'is-invalid': form.errors.has('fixed_tax') }">
                            <has-error :form="form" field="fixed_tax"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Amount Exceeding </label>
                            <input v-model="form.amount_exceeding" type="text" name="amount_exceeding" class="form-control" :class="{ 'is-invalid': form.errors.has('amount_exceeding') }">
                            <has-error :form="form" field="amount_exceeding"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Percentage On Amount Exeeding </label>
                            <input v-model="form.percentage_amount_exceeding" type="text" name="percentage_amount_exceeding" class="form-control" :class="{ 'is-invalid': form.errors.has('percentage_amount_exceeding') }">
                            <has-error :form="form" field="percentage_amount_exceeding"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/incomeTaxSlabs" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="crud_income_tax_slabs === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_income_tax_slabs === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                incomeTaxSlabs : {},
                form: new Form({
                    min_income : '',
                    max_income : '',
                    fixed_tax : '',
                    amount_exceeding : '',
                    percentage_amount_exceeding : '',
                }),
                crud_income_tax_slabs: null
            }
        },
        methods: {
            addIncomeTaxSlabData() {
                this.$Progress.start();
                this.form.post('api/addIncomeTaxSlab')
                .then(res => {
                    if(res.status == 200){
                        this.resetForm();
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Income tax slab created successfully'
                        });
                        this.$router.push('/incomeTaxSlabs');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            resetForm() {
                this.min_income = '';
                this.max_income = '';
                this.fixed_tax = '';
                this.amount_exceeding = '';
                this.percentage_amount_exceeding = '';
            },
        },
        mounted() {
            this.$Progress.start();
			this.can('crud_income_tax_slabs').then(result => {
                this.crud_income_tax_slabs = result.crud_income_tax_slabs;
            }).then(result => {
                if(this.crud_income_tax_slabs == true){
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>
